import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import Link from "next/link";

interface CallToActionBlockProps {
  smallText: string;
  title: string;
  subtitle: string;
  buttonText: string;
  href?: string;
  glow?: "teal" | "blue" | "gold" | "violet";
  delay?: number;
}

const glowMap: Record<NonNullable<CallToActionBlockProps["glow"]>, string> = {
  teal: "text-brand-teal",
  blue: "text-blue-400",
  gold: "text-amber-400",
  violet: "text-violet-400",
};

const CallToActionBlock = ({
  smallText,
  title,
  subtitle,
  buttonText,
  href = "/register",
  glow = "teal",
  delay = 0.5,
}: CallToActionBlockProps) => {
  return (
    <section className="w-full mx-auto px-6 pb-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay:0.4 }}
        className="cta"
      >
        <div className="cta-content">
          <p
            className={`${glowMap[glow]} text-sm sm:text-base font-semibold uppercase tracking-wide mb-3 sm:mb-5`}
          >
            {smallText}
          </p>
          <h3 className="text-xl sm:text-3xl font-bold text-brand-white-light mb-3">
            {title}
          </h3>
          <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-6 max-w-xl">
            {subtitle}
          </p>
          <Link
            href={href}
            className="group inline-flex items-center gap-2 mt-2 rounded-full bg-brand-white-light border border-brand-stroke/50 px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold text-brand-black transition-all duration-200 hover:opacity-80"
          >
            {buttonText}
            <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default CallToActionBlock;